import { createTheme, ThemeProvider } from "@mui/material/styles";
import { green } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    primary: {
      main: "#AE0066",
    },
    secondary: {
      main: green[500],
    },
  },
});

export const ThemeBenetworks = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
